<template>
  <div class="app" :class="`current-scene-${currentScene}`">
    <div class="stage">
      <div class="stage__padding">
        <div class="stage__inner">
          <!-- <button
            class="scene__nav scene__nav--previous button"
            v-if="currentScene > 1"
            @click="previousScene()"
          >
            <span class="scene__nav-inner">Back</span>
          </button>
          <button
            class="scene__nav scene__nav--next button"
            @click="nextScene()"
            v-if="!beginButton"
          >
            <span class="scene__nav-inner">{{ nextButtonText }}</span>
          </button> -->
          <!-- <button
            class="mute"
            :class="{
              'muted': muted
            }"
            @click="toggleMute()"
          >toggle mute</button> -->
          <button class="scene__begin button" @click="begin()" v-if="beginButton">Click To Begin</button>
          <div
            class="scene scene-1"
            :class="{
              'active': currentScene === 1,
              'active-play': currentScene === 1 && !beginButton
            }"
          >
           <!-- MICRO Scene 1 -->
            <div class="scene-1__background"></div>
            <div class="scene-1__text"><p class="scene-text">A spot is a special kind of TV commercial that promotes a particular show or event. It airs on the network between other shows.</p></div>
            <div class="scene-1__tv-button"></div>
            
          <!-- MICRO Scene 2 -->
            <div
              class="scene-1__TV-show"
                :class="{
                'activate': trackTime >= 9
              }"
            > <show ref="show"></show>
            </div>
            <!-- MICRO Scene 3 -->
            <div
              class="scene-1__TV-spot"
                :class="{
                'activate': trackTime >= 13.5
              }"
            ><spot ref="spot"></spot>
            </div>
               <!-- MICRO Scene 4 -->
          <div
            class="scene-1__script"
                :class="{
                'activate': trackTime >= 22.5
              }"
            >
            <p class="scene-text">Today, the producer is creating a spot to promote the Kids Work! ETV News. The first step is to write the script. Help the producer by filling in the blanks with words. Press the SAVE button to save your script. </p>
            
          <form @submit.prevent="onSubmit">
              <input class="save-button" type="submit" value="Save">
              <a href="#" class="help-button">Help</a>
              <div class="glossary">
                <h4>Help</h4>
                  <p>A <span class="highlight">noun</span> is a word that names a person, a place, thing or event.</p>
                  <p class="indent">EXAMPLE: I love to play <span class="element">sports</span>.</p>

                  <p>An <span class="highlight">adjective</span> is a word that describes a noun.</p>
                  <p class="indent">EXAMPLE: We have a <span class="element">large</span> backyard.</p>

                 <p>A <span class="highlight">verb</span> is word that can show action.</p>
                  <p class="indent">EXAMPLE: We <span class="element">ran</span> from the dog.</p>

                  <p>An <span class="highlight">adverb</span> is a word that describes a verb.</p>
                  <p class="indent">EXAMPLE: I read a book <span class="element">quickly</span>.</p>
              </div>

            <div class="script-line first-line">
                <p>Kids Work! News is</p>
                <span class="form-item smaller-input">
                  <label for="adjective">(Adjective)</label>
                  <input name="adjective" ref="adjectivefield" maxlength="14" /> !
                </span>
                <p>We work</p>
                <span class="form-item smaller-input">
                  <label for="adverb">(Adverb)</label>
                  <input name="adverb" ref="adverbfield" maxlength="14"/>
                </span>
              </div>

              <div class="script-line second-line">
                <p>To bring you stories about Sports,</p>
                <span class="form-item">
                  <label for="noun">(Noun)</label>
                  <input name="noun" ref="nounfield" maxlength="17"/>
                </span>
                <p>and</p></div>
              <div class="script-line third-line">
                <span class="form-item">
                  <label for="noun1">(Noun)</label>
                  <input name="noun1" ref="noun1field" maxlength="17"/>
                </span> <p>for kids and by kids.</p>
              </div>

              <div class="script-line fourth-line">
                  <p>Kids Work! ETV reports news that you can</p> 
                <span class="form-item">
                  <label for="verb">(Verb)</label>
                  <input name="verb" ref="verbfield" maxlength="17"/>
                </span>
              </div>
      </form>
              <div class="help-glossary">

              </div>
            </div>
          </div>  
 
        
        <div
            class="scene scene-2"
            :class="{
              'active': currentScene === 2
            }"
          >
            <!-- <h2>Scene 2</h2> -->
            <p class="scene-text">The producer selects the graphics and music to go with the script. An editor puts it all together on a computer video editing system. Select an image to go with your script</p>
           

            <div class="tv-select" :class="boxGraphicValue + '-color'">
              <!-- <h4>Kids Work! TV Graphic Files</h4> -->
            </div>
            <ul class="graphic-list">
              <li><a href="#" class="graphic orange" @click="nextScene()" @mouseenter="boxGraphicValue = 'tv-orange'" @focus="boxGraphicValue = 'tv-orange'">orange</a></li>
              <li><a href="#" class="graphic green" @click="nextScene()" @mouseenter="boxGraphicValue = 'tv-green'" @focus="boxGraphicValue = 'tv-green'">green</a></li>
              <li><a href="#" class="graphic blue" @click="nextScene()" @mouseenter="boxGraphicValue = 'tv-blue'" @focus="boxGraphicValue = 'tv-blue'">blue</a></li>
              <li><a href="#" class="graphic pink" @click="nextScene()" @mouseenter="boxGraphicValue = 'tv-pink'" @focus="boxGraphicValue = 'tv-pink'">pink</a></li>
            </ul>
          </div>
          <div
            class="scene scene-3"
            :class="{
              'active': currentScene === 3
            }"
          >
            <!-- <h2>Scene 3</h2> -->
            <p class="scene-text">Now you need to select music to go with your TV promotional spot. Click the listen button to hear the music.</p>
            <div>
              <div class="tv-select" :class="boxGraphicValue + '-color'"></div>
              <ul class="music-list">
                <li>
                  <a href="#" class="music country" @click="toggleAudioByName('sampleCountry')">Country</a>
                  <a href="#" class="select-dot"  @click="nextScene()" @focus="boxMusicValue = 'finalCountry'">Select Country Music</a>
                </li>
                <li>
                  <a href="#" class="music pop" @click="toggleAudioByName('samplePop')">Pop</a>
                  <a href="#" class="select-dot"  @click="nextScene()" @focus="boxMusicValue = 'finalPop'">Select Pop Music</a>
                  </li>
                <li>
                  <a href="#" class="music techno" @click="toggleAudioByName('sampleTechno')">Techno</a>
                  <a href="#" class="select-dot"  @click="nextScene()" @focus="boxMusicValue = 'finalTechno'">Select Techno Music</a>
                </li>
                <li>
                  <a href="#" class="music urban" @click="toggleAudioByName('sampleUrban')">Urban</a>
                  <a href="#" class="select-dot"  @click="nextScene()" @focus="boxMusicValue = 'finalUrban'">Select Urban</a>
                </li>
              </ul>
            </div>
          </div>
          <div
            class="scene scene-4"
            :class="{
              'active': currentScene === 4
            }"
          >
            <p class="scene-text">Press the PLAY button to watch your KidsWork! News spot. Press EJECT to end the activity.</p>
            <div class="tv-select" :class="boxGraphicValue + '-color'" ></div>
            <a href="#" class="tv-button play" :class="boxMusicValue"  @click="nextScene(), toggleAudioByName(boxMusicValue)">Play</a>
            <a href="https://www.knowitall.org/series/television-job-play" class="tv-button eject">Eject</a>
            <a href="#" class="tv-button rewind">Rewind</a>
          </div>
          
           <div
            class="scene scene-5"
            :class="{
              'active': currentScene === 5
            }"
          >
            <p class="scene-text">Press the PLAY button to watch your KidsWork! News spot. Press EJECT to end the activity.</p>
            <div class="tv-select" :class="boxGraphicValue + '-color'" ></div>
              <a href="#" class="tv-button play" :class="boxMusicValue" @click="nextScene()">Play</a>
              <a href="https://www.knowitall.org/series/television-job-play" class="tv-button eject">Eject</a>
              <a href="#" @click="previousScene()" class="tv-button rewind" >Rewind</a>
              
            
            <blueSpot ref="spot-blue" :class="boxGraphicValue"></blueSpot>
            <greenSpot ref="spot-green" :class="boxGraphicValue"></greenSpot>
            <pinkSpot ref="spot-pink" :class="boxGraphicValue"></pinkSpot>
            <orangeSpot ref="spot-orange" :class="boxGraphicValue"></orangeSpot> 

            <div :class="boxGraphicValue + '-template'">
              <p class="scene-text-template first"
              :class="{
                  'activate': trackTime >= 1,
                  'hide': trackTime >= 3
              }"
              >
              Kids Work!<br>ETV News is<br>
              <span class="scene-text-output adjective">
              {{ adjective }}
              </span></p>

              <p class="scene-text-template second"
              :class="{
                  'activate': trackTime >= 3,
                  'hide': trackTime >= 5
              }"
              >We work <span class="scene-text-output adverb">{{ adverb }}</span><br>to bring you the stories<br>that you care about.</p>
              
              <p class="scene-text-template third"
              :class="{
                  'activate': trackTime >= 5,
                  'hide': trackTime >= 6
              }"
              >Sports</p>
              <p class="scene-text-template fourth"
               :class="{
                  'activate': trackTime >= 6,
                  'hide': trackTime >= 8
              }"
              >Sports<br>
              <span class="scene-text-output noun">{{ noun }}</span></p>

               <p class="scene-text-template fifth"
               :class="{
                  'activate': trackTime >= 8,
                  'hide': trackTime >= 9
              }"
               > and <br>
                <span class="scene-text-output noun1">{{ noun1 }}</span>
               </p>

              <p class="scene-text-template sixth"
              :class="{
                  'activate': trackTime >= 9,
                  'hide': trackTime >= 10
              }"
              >For kids, </p>
              <p class="scene-text-template seventh"
              :class="{
                  'activate': trackTime >= 10,
                  'hide': trackTime >= 11
              }"
              >by kids. </p>

              <p class="scene-text-template eighth"
              :class="{
                  'activate': trackTime >= 11,
                  'hide': trackTime >= 12
              }"
              >Kids Work!<br>ETV News</p>
              <p class="scene-text-template nineth"
              :class="{
                  'activate': trackTime >= 12,
                  'hide': trackTime >= 13.5
              }"
              >reports news<br>that you can<br>
               <span class="scene-text-output verb"
               :class="{
                  'activate': trackTime >= 13.5,
                  'hide': trackTime >= 15
              }"
               >{{ verb }}</span>
              </p>
             
              <div class="scene-text-template closing"
                :class="{
                  'activate': trackTime >= 14.5
              }"
                >
                 <div class="text K"
                      :class="{
                        'activate': trackTime >= 15,
                        'move': trackTime >= 15.5
                      }"
                      >K</div>
                      <div class="text W"
                      :class="{
                        'activate': trackTime >= 15.5,
                        'move': trackTime >= 16
                      }"
                      >W</div>
                      <div class="text E"
                      :class="{
                        'activate': trackTime >= 16,
                        'move': trackTime >= 16.5
                      }"
                      >E</div>
                      <div class="text T"
                      :class="{
                        'activate': trackTime >= 16.5,
                        'move': trackTime >= 17
                      }"
                      >T</div>
                      <div class="text V"
                      :class="{
                        'activate': trackTime >= 17,
                        'move': trackTime >= 17.5
                      }"
                      >V</div>                
                    <p
                      class="scene-text-template production"
                        :class="{
                          'activate': trackTime >= 18
                         }">Productions</p>
                  </div>
              </div>
          </div>

        </div>
      </div>    
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import spot from "@/components/spot.vue";
import show from "@/components/show.vue";
import blueSpot from "@/components/blue-spot.vue";
import greenSpot from "@/components/green-spot.vue";
import orangeSpot from "@/components/orange-spot.vue";
import pinkSpot from "@/components/pink-spot.vue";

export default {
  name: "app",
  data() {
    return {
      boxGraphicValue: 'select-graphic',
      boxMusicValue: 'select-music',
      adjective: '',
      adverb: '',
      noun: '',
      noun1: '',
      verb: '',
    }
  },
  components: {
    spot,
    show,
    blueSpot,
    greenSpot,
    pinkSpot,
    orangeSpot
  },
  computed: {
    ...mapState([
      "numScenes",
      "currentScene",
      "beginButton",
      "muted",
      "trackTime",
      "spot",
      "show"
      ]),
    nextButtonText() {
      if (this.currentScene < this.numScenes) {
        return "Next";
      } else {
        return "End";
      }
    }
  },
  methods: {
    ...mapMutations(["HIDE_BEGIN_BUTTON", "RESET_TRACK_INTERVAL"]),
    ...mapActions(["begin", "previousScene", "nextScene", "rewindScene", "toggleMute", "toggleAudioByName"]),
    onSubmit() {
      this.adjective = this.$refs.adjectivefield.value;
      this.adverb = this.$refs.adverbfield.value;
      this.noun = this.$refs.nounfield.value;
      this.noun1 = this.$refs.noun1field.value;
      this.verb = this.$refs.verbfield.value;
      this.nextScene();
    }
  }
};
</script>

<style lang="scss">
body {
  background-color: #fff;
}
</style>
